import React from "react";

import Layout from "../../components/layout";
import SEO from "../../components/SEO";
import { JiffyProjectSection } from "../../containers/projects";

const JiffyProjectPage = () => {
  return (
    <Layout>
      <SEO
        title="Jiffy - Projects"
        description="Frontend work across the Jiffy Rails storefront | E-commerce | TypeScript, Vue, Rails, Webpack"
      />
      <JiffyProjectSection />
    </Layout>
  );
};

export default JiffyProjectPage;
